import React from "react";

// antd
import { message, Modal } from "antd";
import { FileOutlined } from "@ant-design/icons";

// Component
import { Dragger } from "../../../Common/FormElements";

// Localization
import LOCALIZATION from "services/LocalizationService";

const Index = ({ excelFile, setExcelFile, confirmOnDelete, onRemove }) => {
  const handlefile = (info) => {
    const status = info.file.status;
    if (status === "success") {
      message.success("File uploaded successfully!");
    } else if (status === "error") {
      message.error("File upload failed!");
    }
    setExcelFile(info.fileList);
  };

  const validateFile = (rule, value, callback) => {
    if (!excelFile || excelFile?.length === 0) {
      callback("File is required");
      return;
    }
    
    if (excelFile && excelFile.length > 0) {
      const allowedFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-excel", // .xls
        "text/csv", // .csv
      ];

      const file = excelFile[0];
      const fileType = file?.originFileObj?.type || file?.type;
      
      const isAllowedFileType = allowedFileTypes.includes(fileType);

      if (!isAllowedFileType) {
        callback("You can only upload Excel files (.xlsx, .xls) or CSV files.");
        return;
      }
      
      // Check file size (25MB limit)
      const maxSize = 25 * 1024 * 1024;
      const fileSize = file?.originFileObj?.size || file?.size;
      if (fileSize > maxSize) {
        callback("File size must be less than 25MB");
        return;
      }
    }
    
    callback();
  };

  const removeFile = () => {
    if (excelFile[0]?.status === "uploading") return false;
    if (confirmOnDelete) {
      return new Promise((resolve) => {
        Modal.confirm({
          title: LOCALIZATION.DELETE_FILE_TITLE,
          icon: null,
          closable: true,
          closeIcon: <i className="icon-clear"></i>,
          content: LOCALIZATION.DELETE_FILE_MESSAGE,
          okButtonProps: "seconday",
          okText: LOCALIZATION.DELETE_FILE,
          okType: "primary",
          cancelText: LOCALIZATION.KEEP_FILE,
          onOk: () => {
            if (onRemove) onRemove();
            setExcelFile([]);
            resolve();
          },
          onCancel: () => {
            resolve(false);
          },
          className: `meesagesModal`,
        });
      });
    } else {
      setExcelFile([]);
    }
  };

  return (
    <>
      <Dragger
        listType={"picture"}
        name={"file"}
        accept={".xlsx , .xls , .csv"}
        onChange={handlefile}
        maxCount={1}
        fileList={excelFile}
        validator={{ validator: validateFile }}
        onRemove={removeFile}
        onUplaodAction={false}
        hideDragger={excelFile?.length >= 1}
      />
    </>
  );
};

export default Index;
